import React from 'react'
import { BsLinkedin, BsGithub } from 'react-icons/bs'
import { FaFacebookF } from 'react-icons/fa'
import { motion } from 'framer-motion'

const SocialMedia = () => (
  <motion.div
    whileInView={{
      opacity: [0, 1],
      transition: {
        duration: 1,
        ease: 'easeInOut',
      },
    }}
    className='app__social'
  >
    <a
      className='dark:bg-black dark:border-black dark:hover:bg-slate-800 dark:hover:border-slate-800'
      href='https://www.linkedin.com/in/taha-ebaed/'
      title='Linkedin Profile'
    >
      <BsLinkedin className='dark:text-white' />
    </a>
    <a
      className='dark:bg-black dark:border-black dark:hover:bg-slate-800 dark:hover:border-slate-800'
      href='https://github.com/tahaebaed'
      title='Github Profile'
    >
      <BsGithub className='dark:text-white' />
    </a>
    <a
      className='dark:bg-black dark:border-black dark:hover:bg-slate-800 dark:hover:border-slate-800'
      href='https://www.facebook.com/taha.ebaed/'
      title='FB Profile'
    >
      <FaFacebookF className='dark:text-white' />
    </a>
  </motion.div>
)

export default SocialMedia
